import Swal from "sweetalert2";

export const DeleteAlert = () => {
    Swal.fire({
        title: 'Do you want to Delete?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire(
                'Deleted Succesfully.',
            )
        }
    })
};
export const SaveAlert = () => {
    Swal.fire({
        position: 'top-bottom',
        icon: 'success',
        title: 'Your work has been saved',
        showConfirmButton: false,
        timer: 1500
    })
}

export const successAlertRefresh = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "success",
        backdrop: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((refresh) => {

        if (refresh.isConfirmed) {
            window.location.reload(true)
        }
    })
};
export const successAlert2 = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "success",
        backdrop: true,
        allowOutsideClick: false, // Prevents closing by clicking outside
        allowEscapeKey: false

    })
};
export const failureAlert = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "error",
        backdrop: false
    })
};

export const InfoAlert = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "info",
        backdrop: false
    })
};
export default async function Sweetalert(text, icon) {
    const isConfirm = await Swal.fire({
        text: text, icon: icon, confirmButtonColor: '#3085d6',
        allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false, confirmButtonText: "Ok"
    });
    return isConfirm;

}
export function SweetalertOKFunction(text, icon) {
    const isConfirm = Swal.fire({
        text: text, icon: icon, showCancelButton: false,
        confirmButtonColor: '#3085d6', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false, cancelButtonColor: '#d33', confirmButtonText: 'OK'
    });
    return isConfirm;

}
export function SweetalertOKCancelFunction(text, icon) {
    const isConfirm = Swal.fire({
        text: text, icon: icon, showCancelButton: true,
        confirmButtonColor: '#3085d6', allowEnterKey: false,
        reverseButtons: true, allowEscapeKey: false, allowOutsideClick: false, cancelButtonColor: '#d33',
        cancelButtonText: 'Cancel', confirmButtonText: 'Procced to Pay',
    });
    return isConfirm;
}
export function SweetalertCancelFunction(text, icon) {
    const isConfirm = Swal.fire({ text: text, icon: icon, showCancelButton: true, confirmButtonColor: '#3085d6', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false, cancelButtonColor: '#d33', confirmButtonText: 'Yes' });
    return isConfirm;

}

export const successAlertEsign = (responseDesc, getFunction, params) => {
    Swal.fire({
        text: responseDesc,
        icon: "success",
        backdrop: false,
    }).then((refresh) => {
        if (refresh.isConfirmed) {
            // getFunction();
        }
    })
};